<template>
    <div id="app-mount">
        <div>
            <div class="HomeContainer">
                <global-header></global-header>
                <section id="Home">
                    <div class="HomeInner">
                        <div class="HomeTop">
                            <div class="textWrapper">
                                <h1>Add The Power of Japanese Wikipedia to your Discord server!</h1>
                            </div>
                            <div class="buttonsWrapper">
                                <div class="buttonWrapper">
                                    <a href="https://discordapp.com/oauth2/authorize?client_id=454890215182696449&permissions=0&scope=bot" target="_blank">
                                        <button type="button" class="button brand default large grow">
                                            <img src="../assets/discord_icon.svg" alt="Wikipedia ja">Add to Discord</button>
                                    </a>
                                </div>
                                <div class="buttonWrapper">
                                    <a href="/#/features">
                                        <button type="button" class="button black default large grow ">Learn More</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalHeader from './GlobalHeader.vue'
export default {
  name: 'TopPage',
  components: { GlobalHeader },
  methods: {
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.headerForeground {
  position: absolute;
  width: 100%;
  z-index: 1000;
  height: 30px;
}

.mobileHeader {
  font-family: Whitney, "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 72px;
  margin: 0 auto;
  padding: 4px 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: none;
}

.mobileHeaderInner {
    padding: 0 18px;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    height: 100%;
    position: relative;
}

.mobileHeaderLogo {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    margin: auto;
}

.mobileHeaderLogo a {
    text-decoration: None;
    cursor: pointer;
    font-weight: 700;
    font-size: 15px;
    color: #fff;
}

.burgerToggle {
    border: 0;
    background: 0 0;
    cursor: pointer;
}

.burgerToggle.active .burgerIcon {
    background-color: transparent;
}

.burgerToggle.active .burgerIcon:before {
    -webkit-transform: translateY(5px) rotate(45deg);
    -moz-transform: translateY(5px) rotate(45deg);
    -o-transform: translateY(5px) rotate(45deg);
    -ms-transform: translateY(5px) rotate(45deg);
    transform: translateY(5px) rotate(45deg);
}

.burgerToggle.active .burgerIcon:after {
    -webkit-transform: translateY(-5px) rotate(-45deg);
    -moz-transform: translateY(-5px) rotate(-45deg);
    -o-transform: translateY(-5px) rotate(-45deg);
    -ms-transform: translateY(-5px) rotate(-45deg);
    transform: translateY(-5px) rotate(-45deg);
}

.burgerIcon, .burgerIcon:before, .burgerIcon:after {
    display: block;
    width: 17px;
    height: 2px;
    -webkit-transition: background-color .3s linear,-webkit-transform .3s linear;
    -moz-transition: background-color .3s linear,-moz-transform .3s linear;
    -o-transition: background-color .3s linear,-o-transform .3s linear;
    -ms-transition: background-color .3s linear,-ms-transform .3s linear;
    transition: background-color .3s linear,transform .3s linear;
    border-radius: 3px;
    background-color: #fff;
}

.burgerIcon {
    position: relative;
    margin: 5px auto;
}

.burgerIcon:before {
    top: -5px;
}

.burgerIcon:before, .burgerIcon:after {
    position: absolute;
    content: "";
}

.burgerIcon:after {
    top: 5px;
}

.mobileHeaderLeftNav {
    position: absolute;
    width: 100%;
    top: 67px;
    left: 0;
    padding: 0;
    margin: 0;
    font-family: open sans,Helvetica,arial,sans-serif;
    display: none;
    z-index: 1000;
}

.mobileHeaderLeftNav.open {
    display: block;
}

.mobileHeaderLeftNav li {
    padding: 10px 25px;
    border-bottom: 1px solid rgba(255,255,255,.1);
}

.mobileHeaderLeftNav li a {
    font-size: 13px;
    text-decoration: none;
    color: #ccc;
}

@media screen and (max-width: 640px) {
  .mobileHeader {
      display: block;
  }
}

@media (max-width: 640px) {
  .desktopHeader {
      display: none;
  }
}

.headerTransparent {
    background: 0 0;
}

.headerBlack {
    background-color: #23272A;
}

.desktopHeader {
  font-family: Whitney, "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 72px;
  margin: 0 auto;
  padding: 8px 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.desktopHeaderLogo a {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    -o-box-orient: horizontal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    text-decoration: None;
    cursor: pointer;
    font-weight: 700;
    font-size: 18px;
    color: #fff;
}

.desktopHeaderLeftNavItem a {
    color: #fff;
    opacity: .7;
    -ms-filter: "alpha(opacity=70)";
    filter: alpha(opacity=70);
    cursor: pointer;
    text-decoration: None;
    padding: 15px 10px;
    font-weight: 400;
    font-size: 12px;
    -webkit-transition: opacity 175ms ease-out;
    -moz-transition: opacity 175ms ease-out;
    -o-transition: opacity 175ms ease-out;
    -ms-transition: opacity 175ms ease-out;
    transition: opacity 175ms ease-out;
}

.desktopHeaderInner {
  padding: 0 30px;
  display: -webkit-box;
  display: -moz-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: box;
  display: flex;
  -webkit-box-align: center;
  -moz-box-align: center;
  -o-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 100%;
  max-width: 1600px;
  margin: auto;
}

.desktopHeaderLeftNav {
    list-style: none;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    -o-box-flex: 1;
    box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-family: open sans,sans-serif,Helvetica,arial,sans-serif;
}

.desktopHeaderRightNav {
    list-style: none;
}

.desktopHeaderLeftNav, .desktopHeaderRightNav {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.desktopHeaderRightNavItem {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    -o-box-orient: horizontal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.desktopHeaderRightNavItem a {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -o-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    opacity: .7;
    -ms-filter: "alpha(opacity=70)";
    filter: alpha(opacity=70);
    cursor: pointer;
    padding: 15px 15px 15px 0;
    -webkit-transition: opacity 175ms ease-out;
    -moz-transition: opacity 175ms ease-out;
    -o-transition: opacity 175ms ease-out;
    -ms-transition: opacity 175ms ease-out;
    transition: opacity 175ms ease-out;
}

.desktopHeaderRightNavItem a:hover {
    opacity: 1;
    -ms-filter: none;
    filter: none;
}

#Home {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: absolute;
  padding-top: 72px;
  background-color: #2C2F33;
  display: -webkit-box;
  display: -moz-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: box;
  display: flex;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -o-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -moz-box-align: center;
  -o-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -o-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}

#Home .HomeInner {
    position: relative;
    width: 100%;
    height: 100%;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    -o-box-flex: 1;
    box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -o-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

#Home .HomeTop {
    max-width: 1440px;
    margin-bottom: 10%;
    padding-left: 10%;
    padding-right: 10%;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -o-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    -o-box-flex: 1;
    box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 50%;
    z-index: 200;
}

#Home .textWrapper {
    margin-bottom: 15px;
    font-family: Whitney, "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-align: center;
}

#Home .buttonsWrapper {
    margin-top: 15px;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    -o-box-orient: horizontal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

#Home .buttonsWrapper .buttonWrapper {
    margin-left: 10px;
    margin-right: 10px;
    width: 200px;
}

.button.brand.default {
    background-color: #7289DA;
}

.button.black.default {
    background-color: #000;
}

.button.grow {
    width: 100%;
}

.button.large {
    height: 60px;
}

.button {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: open sans,Helvetica,arial,sans-serif;
    line-height: 1;
    font-weight: 600;
    cursor: pointer;
    min-height: 32px;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    border-radius: 3px;
    border: 0;
    font-size: 14px;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -moz-box-align: center;
    -o-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    padding: 10px 30px;
    color: #fff;
    -webkit-transition: border 180ms ease-out,background 180ms ease-out;
    -moz-transition: border 180ms ease-out,background 180ms ease-out;
    -o-transition: border 180ms ease-out,background 180ms ease-out;
    -ms-transition: border 180ms ease-out,background 180ms ease-out;
    transition: border 180ms ease-out,background 180ms ease-out;
    color: #fff;
    -webkit-transition: border 180ms ease-out,background 180ms ease-out;
    -moz-transition: border 180ms ease-out,background 180ms ease-out;
    -o-transition: border 180ms ease-out,background 180ms ease-out;
    -ms-transition: border 180ms ease-out,background 180ms ease-out;
    transition: border 180ms ease-out,background 180ms ease-out;
}

#Home .buttonsWrapper .buttonWrapper img {
    margin-right: 12px;
    width: 22px;
}

@media (max-width: 800px) {
  #Home .buttonsWrapper {
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -o-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  #Home .buttonsWrapper .buttonWrapper {
    margin-bottom: 20px;
  }
}

button {
    outline: 0;
}

a,
abbr,
acronym,
address,
applet,
big,
blockquote,
body,
caption,
cite,
code,
dd,
del,
dfn,
div,
dl,
dt,
em,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
html,
iframe,
img,
ins,
kbd,
label,
legend,
li,
object,
ol, p, pre, q, s, samp, small, span, strike, strong, sub, sup, table, tbody, td, tfoot, th, thead, tr, tt, ul, var {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 0;
    font-family: inherit;
    font-size: 100%;
    font-style: inherit;
    font-weight: inherit;
    margin: 0;
    outline: 0;
    padding: 0;
    vertical-align: baseline;
}

#Home .textWrapper h1 {
    font-weight: 600;
    font-size: 28px;
    margin-bottom: 3px;
    padding: 0;
    line-height: 1;
}

.textWrapper h1 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 5px;
    text-transform: capitalize;
}

.textWrapper h1, .textWrapper p {
    font-family: Whitney, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h1 {
    font-family: Whitney, "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-transform: uppercase;
    color: #fff;
    padding: 20px 0 10px;
    font-size: 20px;
    font-weight: 600;
}

#Home .textWrapper p {
    font-family: open sans;
    font-weight: 400;
    font-size: 14px;
    margin: 0;
    margin-top: 8px;
}

.textWrapper p {
    margin-top: 15px;
    color: rgba(255,255,255,.77);
    font-size: 14px;
}

.textWrapper h1, .textWrapper p {
    font-family: Whitney, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TopPage.vue